/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 気道確保実施
 */
export type TreatmentAirwayManagementExecuteEnum =
  (typeof TreatmentAirwayManagementExecuteEnum)[keyof typeof TreatmentAirwayManagementExecuteEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TreatmentAirwayManagementExecuteEnum = {
  SUCCESS: 'SUCCESS',
  REMOVED: 'REMOVED',
  FAILED: 'FAILED',
  NOT_PERFORMED: 'NOT_PERFORMED',
} as const;
